import React, { Component } from 'react'
import styled from 'styled-components'
import Loader from 'react-loader-spinner'

const OverlayContainer = styled.div`
  position:fixed;
  top:83px;
  left:0;
  z-index:3;
  width:100%;
  height:100%;
  margin:0 auto;
  box-sizing:border-box;
  background: rgba(255,255,255,0.95);
  transition: all 200ms;
`

const Inner = styled.div`
  position: fixed;
  top: 50%;
  left: 47.6%;
  transform: translate(-50%, 0);
  transform: translate(0, -50%);
`

class LoaderOverlay extends Component {

  constructor(props) {
    super(props)
    this.state = {
      opacity: 0
    }
  }

  componentDidMount() {
    this.setState({
      opacity: 1
    })
  }

  componentWillUnmount() {
    this.setState({
      opacity:0
    })
  }

  render() {
    return (
      <OverlayContainer style={{opacity: this.state.opacity }}>
        <Inner>
        <Loader
    	     type="Oval"
    	     color="#7FCEFF"
    	     height="60"
    	     width="60"
    	  />
        </Inner>
      </OverlayContainer>
    )
  }
}

export default LoaderOverlay



// WEBPACK FOOTER //
// ./src/components/LoaderOverlay.js